import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { ChevronRight, BookOpen } from 'lucide-react';

export default function CourseDetail() {
  const { id } = useParams();
  const [course, setCourse] = useState(null);
  useEffect(() => { api.get(`/courses/${id}`).then(r => setCourse(r.data)); }, [id]);
  if (!course) return <div className="p-8">Cargando…</div>;
  return (
    <div className="p-8 max-w-4xl mx-auto">
      <div className="mb-6">
        <div className="text-xs uppercase tracking-widest text-slate-500 font-bold">Curso</div>
        <h1 className="font-display text-4xl font-extrabold" data-testid="course-title">{course.title}</h1>
        <p className="text-slate-600 mt-2">{course.description}</p>
      </div>
      <div className="space-y-6">
        {course.modules.map((m, i) => (
          <div key={m.id} data-testid={`module-${m.id}`} className="rounded-2xl bg-white border border-slate-200 p-6">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-9 h-9 rounded-full bg-blue-100 text-blue-700 grid place-items-center font-bold">{i+1}</div>
              <div>
                <div className="font-display font-bold text-lg">{m.title}</div>
                <div className="text-sm text-slate-500">{m.description}</div>
              </div>
            </div>
            <div className="ml-12 divide-y divide-slate-100">
              {m.lessons.map(l => (
                <Link key={l.id} to={`/student/lessons/${l.id}`} data-testid={`lesson-${l.id}`}
                  className="flex items-center justify-between py-3 hover:bg-slate-50 rounded px-2 -mx-2 transition-colors">
                  <div className="flex items-center gap-3">
                    <BookOpen className="w-4 h-4 text-slate-400"/>
                    <div>
                      <div className="font-semibold text-sm">{l.title}</div>
                      <div className="text-xs text-slate-500 uppercase tracking-wide">{l.kind}</div>
                    </div>
                  </div>
                  <ChevronRight className="w-4 h-4 text-slate-400"/>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
